import { render, staticRenderFns } from "./text.vue?vue&type=template&id=364054c0&functional=true&shadow"
import script from "./text.vue?vue&type=script&lang=js&shadow"
export * from "./text.vue?vue&type=script&lang=js&shadow"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  ,true
)

export default component.exports